"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProfileFormModule = /** @class */ (function () {
    function ProfileFormModule() {
    }
    return ProfileFormModule;
}());
exports.ProfileFormModule = ProfileFormModule;
